import React from 'react';
import { HrnbRow, HrnbCol } from '../../../components/controls/HrnbContainer';
import HrnbCard from '../../../components/controls/HrnbCard';
import HrnbButton from '../../../components/controls/HrnbButton';
import HrnbSelect from '../../../components/controls/HrnbSelect';
import HrnbLoader from '../../../components/controls/HrnbLoader';
import HrnbSkeleton, { SkeletonList } from '../../../components/controls/HrnbSkeleton';
import { STATUS_OPTIONS, getRoleLabel, getParticipantStatusLabel } from '../constants';
import { canManageParticipants } from '../utils';
import { AcceptIcon, RejectIcon } from '../../../icons';

/**
 * Вкладка "Участники" страницы баттла
 */
const BattleParticipantsTab = ({
  participants,
  filterRole,
  filterStatus,
  participantLoading,
  currentUser,
  isUserOrganizer,
  actionLoading,
  onFilterRoleChange,
  onFilterStatusChange,
  onApprove,
  onReject,
  onDisqualify,
}) => {
  return (
    <HrnbRow>
      <HrnbCol xs={12}>
        <HrnbCard title="Участники" className="battle-detail-card">
          <div className="battle-participants-filters">
            <div className="filter-group">
              <label className="filter-label">Роль:</label>
              <HrnbSelect
                value={filterRole}
                onChange={onFilterRoleChange}
                options={[
                  { value: 'PARTICIPANT', label: 'Участники' },
                  { value: 'ORGANIZER', label: 'Организаторы' },
                  { value: 'JUDGE', label: 'Жюри' },
                ]}
                className="filter-select"
              />
            </div>
            <div className="filter-group">
              <label className="filter-label">Статус:</label>
              <HrnbSelect
                value={filterStatus}
                onChange={onFilterStatusChange}
                options={[{ value: '', label: 'Все статусы' }, ...STATUS_OPTIONS]}
                className="filter-select"
              />
            </div>
          </div>

          {participantLoading ? (
            <SkeletonList count={5} />
          ) : participants.length === 0 ? (
            <div className="no-participants">Участники не найдены</div>
          ) : (
            <div className="battle-participants-list">
              {participants.map((p) => (
                <div key={p.id} className="participant-item">
                  <div className="participant-info">
                    <div className="participant-name">
                      {p.nickname || p.name || 'Участник'}
                    </div>
                    <div className="participant-details">
                      <span className="participant-role">
                        {getRoleLabel(p.role)}
                      </span>
                      <span
                        className="participant-status"
                        data-status={p.applicationStatus}
                      >
                        {getParticipantStatusLabel(p.applicationStatus)}
                      </span>
                      {p.city && (
                        <span className="participant-city">{p.city}</span>
                      )}
                    </div>
                  </div>

                  {canManageParticipants(currentUser, isUserOrganizer) &&
                    p.applicationStatus === 'PENDING' && (
                      <div className="participant-actions">
                        <HrnbButton
                          variant="success"
                          size="sm"
                          onClick={() => onApprove(p.id)}
                        >
                          <AcceptIcon style={{ width: 14, height: 14, marginRight: 6 }} />
                          Одобрить
                        </HrnbButton>
                        <HrnbButton
                          variant="danger"
                          size="sm"
                          onClick={() => onReject(p.id)}
                        >
                          <RejectIcon style={{ width: 14, height: 14, marginRight: 6 }} />
                          Отклонить
                        </HrnbButton>
                      </div>
                    )}

                  {currentUser &&
                    isUserOrganizer &&
                    p.applicationStatus === 'APPROVED' && (
                      <div className="participant-actions">
                        <HrnbButton
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            onDisqualify(p.id, p.nickname || p.name || 'Участник')
                          }
                          disabled={actionLoading}
                        >
                          {actionLoading ? (
                            <HrnbLoader size="sm" />
                          ) : (
                            <>
                              <RejectIcon style={{ width: 14, height: 14, marginRight: 6 }} />
                              Дисквалифицировать
                            </>
                          )}
                        </HrnbButton>
                      </div>
                    )}
                </div>
              ))}
            </div>
          )}
        </HrnbCard>
      </HrnbCol>
    </HrnbRow>
  );
};

export default BattleParticipantsTab;
